import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../../api/services/api.service';
import { ScanTokenDef, Wallet, WalletCheckQueueDto } from '../../../../api/models/fraud.models';
import { take } from 'rxjs';
import { DecimalPipe, NgClass } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { DialogService } from '../../../services/dialog.service';
import { getSubscriptionApiErrorMessage } from '../../../utils/subscription-error.utils';

@Component({
  selector: 'app-dialog-verify-general-aml-report',
  imports: [
    MatIcon,
    MatDialogClose,
    NgClass,
    DecimalPipe
],
  templateUrl: './dialog-verify-aml-report.component.html',
  styleUrl: './dialog-verify-aml-report.component.scss'
})
export class DialogVerifyAmlReportComponent {
  private readonly wallet: Wallet = inject<Wallet>(MAT_DIALOG_DATA);
  public readonly _apiService: ApiService = inject(ApiService);
  public readonly matDialogRef = inject(MatDialogRef);
  public readonly authService: AuthService = inject(AuthService);
  public readonly loadingCheckWallet: WritableSignal<boolean> = signal(false);
  private readonly _dialogService: DialogService = inject(DialogService);
  private readonly _matSnackBar: MatSnackBar = inject(MatSnackBar);
  private readonly _translateService: TranslateService = inject(TranslateService);

  public readonly amlReportPrice: Signal<number> = computed(() => {
    const user = this.authService.accountDto();
    if (user) {
      return user.userPlan.secretSaucePrice ?? 2;
    }
    return 2;
  });
  
  checkWallet(): void {
    if (this.wallet) {
      const wallet = this.wallet;
      this.loadingCheckWallet.set(true);
      const form: {address: string, network: string, tokens?: ScanTokenDef[], walletUuid?: string} = {
        address: wallet.address,
        network: wallet.network,
        tokens: [{
          providers: ['SECRET_SAUCE'],
          token: wallet.walletType === 'AML_ENERGY' ? wallet.coin : wallet.subscriptions[0].token
        }],
        walletUuid: wallet.uuid
      };
      this._apiService.postCheckWallet({...form, reportProcess: 'MONITORING_WALLET_CHECK'}).pipe(take(1)).subscribe({
        next: (value: WalletCheckQueueDto) => {
          this.loadingCheckWallet.set(false);
          this.matDialogRef.close(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loadingCheckWallet.set(false);
          if (error.status === 400 && error.error.code === 7) {
            this.matDialogRef.close(false);
            this._dialogService.openBalanceDialog();
            return;
          }
          const subscriptionError = getSubscriptionApiErrorMessage(error);
          if (subscriptionError?.showToUser) {
            this._matSnackBar.open(
              this._translateService.instant(subscriptionError.messageKey),
              this._translateService.instant('common.buttons.close'),
              { duration: 4000 }
            );
          }
        }
      });
    }
  }
}
